import { API_ROUTES, HTTP_METHODS, PAGE_SIZE } from '@Utils/constants';
import { sendCall } from '@Utils/request.utils';

const { ALERT } = API_ROUTES;

class AlertService {
  getAlerts = () => sendCall(ALERT.GET, { method: HTTP_METHODS.GET });

  updateAlerts = (page: number, pagination: boolean, excludeHidden: boolean = false) =>
    sendCall(
      `${ALERT.UPDATE}?page=${page}&limit=${PAGE_SIZE}&pagination=${pagination}&excludeHidden=${excludeHidden}`,
      {
        method: HTTP_METHODS.GET,
      },
    );

  hideAlert = (id: string | undefined) => sendCall(`${ALERT.HIDE}/${id}`, { method: HTTP_METHODS.PUT });

  viewAlert = (id: string | undefined) => sendCall(`${ALERT.VIEW}/${id}`, { method: HTTP_METHODS.PUT });
}

export default new AlertService();
